import { styled } from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  padding: 36px;
`;

export const ComparisonTable = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  thead,
  tbody {
    tr {
      td,
      th {
        align-items: center;
        justify-content: center;
        padding: 12px 24px;
        font-size: 18px;

        &:first-child {
          font-weight: 600;
        }

        &:not(:first-child) {
          text-align: center;
          vertical-align: middle;
          background: ${({ theme }) => theme.colors.default[50]};
          border-bottom: 1px solid ${({ theme }) => theme.colors.default[100]};

          ${({ theme }) => theme.breakpoints.sm.query} {
            padding: 4px !important;
          }
        }
      }
    }
  }

  thead {
    tr th {
      padding: 28px 24px !important;

      &:nth-child(2) {
        border-top-left-radius: 24px !important;
      }

      &:last-child {
        border-top-right-radius: 24px;
      }

      &:not(:last-of-type):not(:first-of-type) {
        border-right: 1px solid ${({ theme }) => theme.colors.default[100]};
      }
    }
  }

  tbody {
    tr {
      td {
        &:not(:last-of-type):not(:first-of-type) {
          border-right: 1px solid ${({ theme }) => theme.colors.default[100]};
        }

        &[data-type="true"] {
          svg {
            color: ${({ theme }) => theme.colors.success.default};
          }
        }

        &[data-type="false"] {
          svg {
            color: ${({ theme }) => theme.colors.error.default};
          }
        }

        ${({ theme }) => theme.breakpoints.sm.query} {
          font-size: 13px;
        }
      }

      &:last-of-type {
        td {
          border-bottom: none;

          &:nth-of-type(2) {
            border-bottom-left-radius: 24px;
          }

          &:last-of-type {
            border-bottom-right-radius: 24px;
          }
        }
      }
    }
  }
`;
